import React, { useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Avatar from '../../../Units/Avatar';
import {
  getCurrentClubApprovedMembers,
  getAccountAvatars
} from '../../../../store/selectors';
import parameters from '../../../../config/parameters';

const playerRow = ({ player, selectedField, avatar, t }) => {
  return (
    <div className={`playerTab`} key={player._id}>
      <div className={`avatarContainer`}>
        <Avatar data={avatar} />
        <div
          className={`roleContainer ${player.isOwner
              ? 'owner'
              : `${parameters.accountTypeIds[player.typeId]}`
            }`}
        >
          <p className={``}></p>
        </div>
      </div>
      <div className={`clubInfo`}>
        <span className={`clubName`}>{player.username}</span>
        <p className={`id`}>
          {t('id')}: {player.globalAccountId}
        </p>
        <span className={`nickname`}>
          {t('nickname')}: <span>{player.nickname}</span>
        </span>
      </div>
      <div className={`fee`}>{player[selectedField]}</div>
    </div>
  );
};

const menuItems = ['wl', 'rake', 'lastLogin'];

const CurrentDownline = () => {
  const { t } = useTranslation();
  const { memberId: memberId } = useParams();
  const [isVisible, setIsVisible] = useState(false);
  const agentId = parseInt(memberId, 10);
  const memberList = useSelector(getCurrentClubApprovedMembers);
  const selectedAgent = useMemo(() => memberList.find(m => m._id === agentId), [
    memberList,
    agentId
  ]);

  const currentDownline = useMemo(() => memberList.filter(
    member =>
      !['manager', 'agent'].includes(
        parameters.accountTypeIds[member.typeId]
      ) && !member.isOwner &&
      member.parentId == selectedAgent.roleAccountId
  ), [memberList, selectedAgent]);

  const avatarList = useSelector(getAccountAvatars);
  const [filteredMemberList, setFilteredMemberList] = useState(currentDownline);
  const [selectedField, setSelectField] = useState(menuItems[0]);
  const [order, setOrder] = useState('');

  const searchMember = e => {
    setFilteredMemberList(
      currentDownline.filter(d => d.username.includes(e.target.value))
    );
  };

  const sortSelectedOrderList = () => {
    if (order.length > 0) {
      setFilteredMemberList(
        [...currentDownline].sort((a, b) =>
          order === 'asc'
            ? a[selectedField] - b[selectedField]
            : b[selectedField] - a[selectedField]
        )
      );
    }
  };

  const sortOrderList = i => {
    setSelectField(i);
    setOrder(order === 'asc' ? 'desc' : 'asc');
  };

  useEffect(() => {
    sortSelectedOrderList();
  }, [memberList, order, selectedField]);

  useEffect(() => {
    setFilteredMemberList(currentDownline);
  }, [currentDownline]);

  return (
    <React.Fragment>
      <p className={`selectDownlineText`}>{t('selectDownlineText')}</p>
      <div className={`searchMember`}>
        <input onChange={e => searchMember(e)} />
        <span className={'searchIcon'}></span>
      </div>
      <div className={`memberCount`}>
        <span>
          {t('members')}({filteredMemberList.length})
        </span>
        <p className={'arrowIcon'}>
          <span>{t(selectedField)}</span>
          <FontAwesomeIcon
            icon={faChevronLeft}
            onClick={() => setIsVisible(true)}
            className="fa chevron-left"
          ></FontAwesomeIcon>
        </p>
      </div>
      {isVisible && (
        <div className={`mainDropdown ${isVisible && 'visible'}`}>
          <div className={`menuList memberDetail`}>
            {menuItems.map(item => (
              <React.Fragment key={item}>
                <div className={'menuItem'} onClick={() => sortOrderList(item)}>
                  <span className="selectedField">{t(item)}</span>
                  <div className="arrows">
                    <span
                      className={`up arrow ${selectedField === item &&
                        order === 'asc' &&
                        'active'}`}
                    ></span>
                    <span
                      className={`down arrow ${selectedField === item &&
                        order === 'desc' &&
                        'active'}`}
                    ></span>
                  </div>
                </div>
                <div className="separatorLine"></div>
              </React.Fragment>
            ))}
          </div>
          <div
            className={`transparentMask`}
            onClick={() => setIsVisible(false)}
          ></div>
        </div>
      )}
      <div className={`memberList selectDownline`}>
        {filteredMemberList.map(player =>
          playerRow({
            player: player,
            selectedField: selectedField,
            avatar: avatarList[player._id],
            t
          })
        )}
      </div>
    </React.Fragment>
  );
};

export default CurrentDownline;
